import { Link } from "react-router-dom";
import { Crown, UserCog, ArrowRight } from "lucide-react";

export default function AdminGate() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-burgundyDeep px-6 py-16 text-cream">
            <div className="mb-14 text-center">
                <img
                    src="https://i.ibb.co/67G6vkDf/Chat-GPT-Image-31-7-2026-19-20-43.png"
                    alt="Vinařství Štrokay"
                    className="h-20 mx-auto mb-6 opacity-95"
                />
                <p className="overline mb-3" style={{ color: "rgba(247,245,240,0.6)" }}>Vinařství Štrokay · interní systém</p>
                <h1 className="font-serif text-5xl md:text-6xl leading-[0.95]">Kdo se přihlašuje?</h1>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl">
                <Link
                    to="/admin/majitel"
                    data-testid="gate-owner"
                    className="group relative bg-cream/[0.04] border border-cream/15 backdrop-blur-sm p-10 hover:bg-cream/10 hover:border-cream/40 transition-all duration-300"
                >
                    <div className="w-14 h-14 flex items-center justify-center bg-cream text-burgundyDeep mb-8">
                        <Crown size={22} />
                    </div>
                    <h2 className="font-serif text-3xl mb-3">Přihlášení pro majitele</h2>
                    <p className="text-sm text-cream/70 leading-relaxed mb-8">
                        Kompletní admin panel — tržby, obsluha, stoly, rezervace, iCal sync, poznámky.
                    </p>
                    <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-semibold group-hover:gap-3 transition-all">
                        Vstoupit <ArrowRight size={13} />
                    </span>
                </Link>

                <Link
                    to="/admin/brigadnice"
                    data-testid="gate-staff"
                    className="group relative bg-cream/[0.04] border border-cream/15 backdrop-blur-sm p-10 hover:bg-cream/10 hover:border-cream/40 transition-all duration-300"
                >
                    <div className="w-14 h-14 flex items-center justify-center bg-cream text-burgundyDeep mb-8">
                        <UserCog size={22} />
                    </div>
                    <h2 className="font-serif text-3xl mb-3">Přihlášení pro brigádnice</h2>
                    <p className="text-sm text-cream/70 leading-relaxed mb-8">
                        Objednávkový systém s mapou stolů před sklepem — přidávání položek a placení.
                    </p>
                    <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-semibold group-hover:gap-3 transition-all">
                        Vstoupit <ArrowRight size={13} />
                    </span>
                </Link>
            </div>

            <Link to="/" className="mt-16 text-[11px] uppercase tracking-[0.22em] text-cream/50 hover:text-cream transition-colors">
                ← zpět na web
            </Link>
        </div>
    );
}
